export const oidcSettings = {
  authority: process.env.VUE_APP_OAUTH_AUTHORITY,
  clientId: process.env.VUE_APP_OAUTH_CLIENT_ID,
  redirectUri: process.env.VUE_APP_OAUTH_REDIRECT_URI,
  postLogoutRedirectUri: process.env.VUE_APP_OAUTH_LOGOUT_URI,
  responseType: 'code',
  scope: 'openid profile user.roles',
  silentRedirectUri: process.env.VUE_APP_OAUTH_SILENT_REDIRECT_URI,
  automaticSilentRenew: true, // If true oidc-client will try to renew your token when it is about to expire.
  automaticSilentSignin: true // If true vuex-oidc will try to silently signin unauthenticated users on public routes. Defaults to true.
};

export const oidcStoreSettings = {
  namespaced: true,
  dispatchEventsOnWindow: true
};
